type RecordWithName = {
  name: string
}

export function normalizeRecordName(value: string) {
  return value.trim().toLowerCase()
}

export function filterRecordsByName<T extends RecordWithName>(
  records: T[],
  query: string
) {
  const normalizedQuery = normalizeRecordName(query)

  if (!normalizedQuery) return records

  return records.filter((record) =>
    record.name.toLowerCase().includes(normalizedQuery)
  )
}

export function hasExactNameMatch<T extends RecordWithName>(
  records: T[],
  query: string
) {
  return findExactNameMatch(records, query) !== undefined
}

export function findExactNameMatch<T extends RecordWithName>(
  records: T[],
  query: string
) {
  const normalizedQuery = normalizeRecordName(query)

  if (!normalizedQuery) return undefined

  return records.find(
    (record) => normalizeRecordName(record.name) === normalizedQuery
  )
}
